import { FC } from 'react';
import cn from 'classnames';

import { Status } from 'constants/enums';
import { EstimatedTime } from 'entities/EstimatedTime';
import { PsychicStatusText } from 'entities/PsychicStatus';
import { capitalizeFirstLetter } from 'lib/text.service';

import styles from './PsychicCardStatusWrapper.module.scss';

import type { IPsychicCardStatusWrapper } from '../config/declarations';

export const PsychicCardStatusWrapper: FC<IPsychicCardStatusWrapper> = ({
  size = 'medium',
  status,
  psychic,
  psychicFrame,
  className,
}) => {
  const sizeClass = styles[`size${capitalizeFirstLetter(size)}`];

  return (
    <div className={cn(styles.wrapper, className)}>
      <PsychicStatusText
        status={status}
        psychic={psychic}
        psychicFrame={psychicFrame}
        className={cn(styles.status, sizeClass)}
        smallTextClass={styles.small}
        wrapperClass={styles.statusTextCombined}
        skipBackInTime
        coloredPart="Bg"
      />
      {status !== Status.AVAILABLE && status !== Status.OFFLINE
          && (
            <EstimatedTime
              texts={psychicFrame.estimatedWaiting}
              timeUnit={psychicFrame.ratePerMinute}
              estimatedTime={status === Status.ON_BREAK
                ? (psychic.onBreakMinutes + psychic.estimatedWaitTime)
                : psychic.estimatedWaitTime}
              isShortText
              className={cn(styles.estimateWait, sizeClass)}
            />
          )}
    </div>
  );
};
